import React, { useState } from 'react';
interface ShowcaseScreen {
  id: string;
  tab: string;
  persona: string;
  personaRole: string;
  image: string;
  caption: string;
}
const screens: ShowcaseScreen[] = [{
  id: 'sales-dashboard',
  tab: 'Sales Dashboard',
  persona: 'Francis',
  personaRole: 'Sales / B2B',
  image: 'https://cdn.magicpatterns.com/uploads/4tkBXnXFD5qdmtC9eo9Ydq/salesdashboard.jpg',
  caption: 'A personalized home base for sales reps — surfacing year-to-date performance, recent estimates and quotes, and new catalog additions at a glance.'
}, {
  id: 'product-quote-dock',
  tab: 'Product & Quote Dock',
  persona: 'Francis',
  personaRole: 'Sales / B2B',
  image: 'https://cdn.magicpatterns.com/uploads/p8oV66FV4WsFMYStHP6oFs/quotedock.jpg',
  caption: 'Product detail pages with related bundles and a persistent quote dock — enabling reps to browse, compare, and build quotes without losing context.'
}, {
  id: 'quote-management',
  tab: 'Quote Management',
  persona: 'Francis',
  personaRole: 'Sales / B2B',
  image: 'https://cdn.magicpatterns.com/uploads/4tyRgv3uNW1cVrjvEo6wGt/quotemanage.jpg',
  caption: 'Kanban-style workflow tracking organizes quotes by status — from draft estimates through customer review to processing — giving reps clear visibility into their pipeline.'
}, {
  id: 'solutions-dashboard',
  tab: 'Solutions Dashboard',
  persona: 'Shae',
  personaRole: 'Product / Business Solutions',
  image: 'https://cdn.magicpatterns.com/uploads/4LgcPZVxYQfwrG9hg8aboE/productdashboard.jpg',
  caption: 'A solutions-focused dashboard for product managers — with quick-start actions, sales analytics by category, and centralized vendor and product management.'
}];
export function DesignShowcase() {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = screens[activeIndex];
  return <div data-id="element-122">
      {/* Tab Bar */}
      <div className="flex gap-2 mb-8 overflow-x-auto pb-2 scrollbar-hide" data-id="element-123">
        {screens.map((screen, i) => <button key={screen.id} onClick={() => setActiveIndex(i)} className={`relative px-5 py-3 rounded-xl text-sm font-medium whitespace-nowrap transition-all duration-300 ${i === activeIndex ? 'bg-white text-black' : 'bg-white/5 text-gray-400 hover:bg-white/10 hover:text-gray-200 border border-white/5'}`} data-id="element-124">
            {screen.tab}
          </button>)}
      </div>

      {/* Image Viewport */}
      <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-zinc-900" data-id="element-125">
        {/* Persona Badge - top left */}
        <div className="absolute top-4 left-4 z-20 flex items-center gap-2 px-3 py-1.5 rounded-full bg-black/60 backdrop-blur-md border border-white/10" data-id="element-126">
          <div className="w-2 h-2 rounded-full bg-yellow-500" data-id="element-127" />
          <span className="text-xs font-medium text-white" data-id="element-128">
            {active.persona}
          </span>
          <span className="text-xs text-gray-400" data-id="element-129">— {active.personaRole}</span>
        </div>

        {/* Screen counter - top right */}
        <div className="absolute top-4 right-4 z-20 px-3 py-1.5 rounded-full bg-black/60 backdrop-blur-md border border-white/10" data-id="element-130">
          <span className="text-xs font-mono text-gray-400" data-id="element-131">
            {String(activeIndex + 1).padStart(2, '0')} /{' '}
            {String(screens.length).padStart(2, '0')}
          </span>
        </div>

        {/* Images with crossfade */}
        <div className="relative aspect-[16/10]" data-id="element-132">
          {screens.map((screen, i) => <img key={screen.id} src={screen.image} alt={screen.tab} className="absolute inset-0 w-full h-full object-cover object-bottom transition-opacity duration-500 ease-out" style={{
          opacity: i === activeIndex ? 1 : 0
        }} data-id="element-133" />)}
        </div>
      </div>

      {/* Caption */}
      <div className="mt-6 flex items-start gap-4" data-id="element-134">
        <div className="flex-shrink-0 w-1 h-full min-h-[40px] rounded-full bg-yellow-500/60" data-id="element-135" />
        <p className="text-gray-400 text-sm leading-relaxed max-w-3xl" data-id="element-136">
          {active.caption}
        </p>
      </div>

      {/* Dot indicators */}
      <div className="flex justify-center gap-2 mt-6" data-id="element-137">
        {screens.map((_, i) => <button key={i} onClick={() => setActiveIndex(i)} className={`rounded-full transition-all duration-300 ${i === activeIndex ? 'w-8 h-2 bg-white' : 'w-2 h-2 bg-white/20 hover:bg-white/40'}`} data-id="element-138" />)}
      </div>
    </div>;
}